import React, { useEffect, useRef, useState } from 'react'
import './TaskDetails.css'
import { useDispatch, useSelector } from 'react-redux';
import { setDispatchAllTask, setEmpLeaveStatus, setIsCommentView, setIsHolidayStatus, setLoader, setProject, setProjectList, setTaskDetailFlag, setTaskDetailObj } from '../../../erpStore/actions';
import profile from "../../../assets/images/profile.png";
import { Calendar } from "primereact/calendar";
import moment from 'moment'
import axios from 'axios';
import { toast } from 'react-toastify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ColumnGroup from 'antd/es/table/ColumnGroup';


function TaskDetails() {
  const selfInfoEmp = useSelector((state) => state.data.taskEmp)
  const dispatch = useDispatch()
  const taskEmp = useSelector((state) => state.data.taskEmp)
  const selfInfo = useSelector((state) => state.data.selfData)
  const empInfo = useSelector((state) => state.data.empInfo)
  const taskDetailObject = useSelector((state) => state.data.taskDetailObject)
  const [taskTitle, setTaskTitle] = useState(taskDetailObject.taskTitle)
  const [DueDate, setStartDate] = useState(taskDetailObject.taskDueDate)
  // const [ScheduleDate, setScheduleDate] = useState(taskDetailObject.taskSchedule)
  const [dateFlag, setDateFlag] = useState(false)
  const [assigneeOption, setAssigneeOption] = useState(false)
  const [departments, setDepartments] = useState(taskDetailObject.tags)
  const dateRef = useRef(null)
  const [tagListForNewAddTask, setTagListInNewTaskAdd] = useState(false)
  const newAddTagRef = useRef(null)
  const assigneeRef = useRef(null)
  const dTags = useSelector((state) => state.data.tagList)
  const [tagsList, setTagsList] = useState([])
  const [statusListForNewAddTask, setStatusListForNewAddTask] = useState(false)
  const dStatuses = useSelector((state) => state.data.statusList)
  const isCommentView = useSelector((state) => state.data.isCommentView)

  const [selectedTaskOwner, setSelectedTaskOwner] = useState(taskDetailObject.taskOwner)
  const dAssignees = useSelector((state) => state.data.assgineeList)
  const [assigness, setAssigness] = useState(dAssignees?.filter(assigneeObj => assigneeObj?.empId.toString() !== taskDetailObject?.taskOwner?.empId.toString()))

  const [statusList, setStatusList] = useState(dStatuses?.filter((obj => obj?.statusId !== taskDetailObject?.statusEntity?.statusId)))
  const [selectedStatus, setSelectedStatus] = useState(taskDetailObject.statusEntity)
  const newAddStatusRef = useRef(null)

  const dPriorities = useSelector((state) => state.data.priorityList)
  const [selectedPriority, setSelectedPriority] = useState(taskDetailObject.priorityEntity)
  const [priorityList, setPriorityList] = useState(dPriorities?.filter(obj => obj?.priorityId !== taskDetailObject?.priorityEntity?.priorityId))
  const [tempPorjectList, setTempPrjList] = useState([])

  const [priorityListForNewAddTask, setPriorityListForNewAddTask] = useState(false)
  const [projectListForNewAddTask, setProjectLitForNewAddTask] = useState(false)

  const newAddProjectRef = useRef(null)
  // const dProjects = useSelector((state) => state.data.projectlistUpdate)
  const [projectListTemp, setProjectListTamp] = useState([])
  const [selectedProject, setSelectedProject] = useState(taskDetailObject.projectEntity)

  const [verifiedListForNewAddTask, setVerifiedListForNewAddTask] = useState(false)
  const dVerifieds = useSelector((state) => state.data.verifiedList)
  const [selectedVerified, setSelectedVerified] = useState(taskDetailObject.task_verified)
  const [verifiedList, setVerifiedList] = useState(dVerifieds?.filter(obj => obj?.verificationStatusId !== taskDetailObject?.task_verified?.verificationStatusId))


  const [gitLink, setGitLink] = useState(taskDetailObject.taskGitLink)
  const [taskComment, setTaskComment] = useState(taskDetailObject.taskComment)

  const newAddPriorityRef = useRef(null)
  const newAddVerifiedRef = useRef(null)

  const [preDfnTip, setPreDfnTip] = useState(false)
  const apiUrl = useSelector((state) => state.data.apiUrl);

  const stringHeaders = window.localStorage.getItem('myHeaders');
  const storedHeaders = JSON.parse(stringHeaders);

  const mtiID = useSelector((state) => state.data.mtiID)

  const dispatchAllTask = useSelector((state) => state.data.dispatchAllTask)
  const editeKey = useSelector((state) => state.data.editeKey)

  const [resetFlag, setResetFlag] = useState(false)
  const getFullDate = useSelector((state) => state.data.fullDate)


  const [toUpdateObj, setToUpdateObj] = useState({ "taskId": taskDetailObject.taskId, "empId": mtiID === true ? null : taskEmp.empId })

  const route = window.sessionStorage.getItem('route')

  const [viewDetailFlag, setViewDetailFlag] = useState(false)

  const viewrRefDtl = useRef(null)

  const [updateLoader, setUpdateLoader] = useState(false)
  const [confirmBtn, setCofirmBtn] = useState(false)

  const [defaultSelectedView, setDeafultSelctedView] = useState(taskDetailObject.taskView)
  const [viewFlag, setViewFlag] = useState(false)
  let flag = false;

  const fullDate = useSelector((state) => state.data.fullDate);
  var date1 = new Date(fullDate);
  // Extract year, month, and day
  var year1 = date1.getFullYear();
  var month1 = ('0' + (date1.getMonth() + 1)).slice(-2); // Adding 1 to month because it starts from 0
  var day1 = ('0' + date1.getDate()).slice(-2);

  // Form the formatted date string
  var formattedDateString = year1 + '-' + month1 + '-' + day1;

  var TodayDteComp = new Date()

  const date3 = new Date(TodayDteComp);
  const formattedDateComp = date3.toISOString().split('T')[0];

  const [taskToTest, setTaskToTest] = useState(false)
  const [isGitProject,setIsGitProject] = useState(taskDetailObject?.projectEntity !== null ? false : true)

  function isJsonParse(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  const removeStringParse = (e) => {
    let jsonString = e;
      var jsonObject = null 
      try {
        jsonObject = JSON.parse(jsonString);
      }catch {
        jsonObject = {"editorData" : `${jsonString}`, "plainData" : `${jsonString}`}
      }

    return jsonObject.editorData
  }
  const [text, setText] = useState(taskDetailObject.taskComment ? removeStringParse(taskDetailObject.taskComment) : '')
  useEffect(() => {
    function handleOutsideClick(event) {
      const refs = [
        { ref: dateRef, setState: setDateFlag },
        { ref: assigneeRef, setState: setAssigneeOption },
        { ref: newAddTagRef, setState: setTagListInNewTaskAdd },
        { ref: newAddStatusRef, setState: setStatusListForNewAddTask },
        { ref: newAddPriorityRef, setState: setPriorityListForNewAddTask },
        { ref: newAddProjectRef, setState: setProjectLitForNewAddTask },
        { ref: newAddVerifiedRef, setState: setVerifiedListForNewAddTask },
        { ref: viewrRefDtl, setState: setViewDetailFlag }
      ];

      refs.forEach(({ ref, setState }) => {
        if (ref && ref.current && !ref.current.contains(event.target)) {
          setState(false);
        }
      });
    }

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const scrollContainerRef = useRef(null);
  const editorRef = useRef(null);
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
  }, []);
  useEffect(() => {
    if (isCommentView) {
      const timer = setTimeout(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight + 90;
        }
      }, 300);

      // Cleanup the timeout if the component unmounts or editorData changes
      return () => clearTimeout(timer);
    }

  }, []);

  const getMonthNumber = (monthName) => {
    const monthMoment = moment().month(monthName).startOf('month');
    return monthMoment.format('MM');
  };


  const splitFullDate = getFullDate.split(" ")
  const mNumber = getMonthNumber(splitFullDate[2])
  const fullDateF2 = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]

  const UPDATE = () => {

    let departmentsIdArr = departments.map(tag => tag.departmentId);
    let checkDetTagsId = taskDetailObject.tags.map(tag => tag.departmentId);

    if (viewFlag === true) {
      axios.put(`${apiUrl}task/update`, { "taskId": taskDetailObject.taskId, "empId": selfInfo.empId, "taskOwner": taskDetailObject.taskOwner.empId }, { headers: storedHeaders })
        .then(response => { })
        .catch(error => {  })
    }

    axios.put(`${apiUrl}task/update`, toUpdateObj, { headers: storedHeaders })
      .then(response => {
        if (response.request.status === 200) {
          const splitFullDate = getFullDate.split(" ")
          const mNumber = getMonthNumber(splitFullDate[2])
          const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
          axios.post(`${apiUrl}task/card/get/day`, {
            "empId": taskEmp.empId,
            "date": fullDateF
          }
            , { headers: storedHeaders })
            .then(response => {
              if (response.request.status === 200) {
                const allTask = response.data.task
                dispatch(setDispatchAllTask(allTask))
                setUpdateLoader(false)
                dispatch(setIsHolidayStatus(response.data.holiday))
                dispatch(setEmpLeaveStatus(response.data.leave))
                dispatch(setTaskDetailFlag(false))
                toast.success("Task updated successfully", { toastId: 'success', autoClose: 2000 });
              }
            })
            .catch(err => {
              toast.error("Error occured", { toastId: 'success', autoClose: 2000 });
              setUpdateLoader(false)
            })

          // const index = dispatchAllTask.findIndex(task => parseInt(task.taskId) === parseInt(taskDetailObject.taskId))
        }
      })
      .catch(error => {
        dispatch(setTaskDetailFlag(false))
        setUpdateLoader(false)

      })
  }


  function isValidGitUrl(url) {
    // Regular expression for GitLab and GitHub URLs
    const gitUrlRegex = /^(https?:\/\/)(?:www\.)?(?:gitlab\.com|github\.com)\/.*/;

    // Check if the URL matches the regex
    return gitUrlRegex.test(url);
  }


  const handleTaskTitle = (e) => {
    if (e.target.value.length <= 100) {
      setTaskTitle(e.target.value)
      if (e.target.value !== taskDetailObject.taskTitle) {
        setToUpdateObj(prevState => ({
          ...prevState,
          ['taskTitle']: e.target.value
        }));

      } else {
        setToUpdateObj(prevState => {
          const newState = { ...prevState };
          delete newState['taskTitle'];
          return newState;
        });
      }
    }
  };

  function checkDepartmentsMatched() {

    const taskDepartmentIds = taskDetailObject.tags.map(tag => tag.departmentId);

    // Copying the departments array
    const tempDepartments = [...departments];

    if (taskDepartmentIds.length === tempDepartments.length && !taskDepartmentIds.every(departmentId => tempDepartments.some(dep => dep.departmentId === departmentId))) {
      let departmentsIdArr = tempDepartments.map(tag => tag.departmentId);
      setToUpdateObj(prevState => ({
        ...prevState,
        ['taskTags']: departmentsIdArr
      }));
      toUpdateObj['taskTags'] = departmentsIdArr
      setToUpdateObj(toUpdateObj)
    } else if (taskDepartmentIds.length !== tempDepartments.length || tempDepartments.length === 0) {
      let departmentsIdArr = tempDepartments.map(tag => tag.departmentId);
      setToUpdateObj(prevState => ({
        ...prevState,
        ['taskTags']: departmentsIdArr
      }));
      toUpdateObj['taskTags'] = departmentsIdArr
      setToUpdateObj(toUpdateObj)
    } else {
      delete toUpdateObj['taskTags'];
      setToUpdateObj(prevState => ({ ...prevState }));
  
    }
  }


  const handleGitLink = (e) => {
    var tempGitLink = e.target.value
    setGitLink(e.target.value)

    if (tempGitLink === '' && taskDetailObject.taskGitLink === null)
      tempGitLink = null

    if (tempGitLink !== taskDetailObject.taskGitLink) {
      setToUpdateObj(prevState => ({
        ...prevState,
        ['taskGitLink']: tempGitLink,
      }));
      if(!taskToTest === false){
        setToUpdateObj(prevState => ({
          ...prevState,
          ['taskToTest']: true,
        }));
      }else{
        setToUpdateObj(prevState => ({
          ...prevState,
          ['taskToTest']: false,
        }));
      }
      toUpdateObj['taskGitLink'] = tempGitLink

    } else {
      delete toUpdateObj['taskGitLink']
      delete toUpdateObj['taskToTest']
      setToUpdateObj(toUpdateObj)
    }
  }
  const [plainText, setPlainText] = useState('');

  function extractPlainText(html) {
    // Replace closing tags with closing tags followed by newline character
    const replacedHtml = html.replace(/<\/(p|h2|h3|h4)>/g, '</$1>\n');

    // Convert HTML to plain text
    const doc = new DOMParser().parseFromString(replacedHtml, 'text/html');
    console.log(doc.body.textContent)
    return doc.body.textContent || '';
  }
  const handleTaskComment = (e) => {

    var tempTaskComment = e
    if (tempTaskComment === '' && taskDetailObject.taskComment === null) {
      tempTaskComment = null
    }

    if (tempTaskComment !== taskDetailObject.taskComment) {
      setToUpdateObj(prevState => ({
        ...prevState,
        ['taskComment']: tempTaskComment
      }));
      toUpdateObj['taskComment'] = tempTaskComment
      setToUpdateObj(toUpdateObj)
    } else {
      delete toUpdateObj['taskComment']
      setToUpdateObj(toUpdateObj)
    }
  }

  useEffect(() => {
    checkDepartmentsMatched();
  }, [departments]);

  useEffect(() => {
    setToUpdateObj(toUpdateObj)
  }, [toUpdateObj])

  useEffect(() => {
    let tempList = dTags;
    taskDetailObject?.tags?.forEach(tagObj => {
      tempList = tempList.filter(obj => obj?.departmentId?.toString() !== tagObj?.departmentId?.toString());
    });
    setTagsList(tempList);
    axios.post(`${apiUrl}project/get/all/for-employee`, { "userId": selfInfoEmp?.userId }, { headers: storedHeaders })
      .then(response => {
        if (response.request.status === 200) {
          setProjectListTamp(response?.data?.filter(obj => obj?.projectId !== taskDetailObject?.projectEntity?.projectId))
          setTempPrjList(response.data)
          dispatch(setProjectList(response.data))
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 500) {
          // navigate("/server-error")
        }
      })
  }, [])

  const isView = (task) => {
    var checkView = defaultSelectedView.some((emp) => selfInfo.empId === emp.empId)
    return !checkView;
  }

  const checkIsProject = () => {
    if(taskDetailObject?.projectEntity !== null){
        setIsGitProject(true)
    }else{
      setIsGitProject(false)
    }
  }

  const isHigherAuthority = () => {
    return selfInfoEmp?.reportingAuthorities?.some((obj) => selfInfo?.empId === obj?.empId) || false;
}


  return (
    <div className='TaskDetail_main_container'>
      <div className='TaskTemplateConatiner' id='unloadViewDtl'>
        <div className='newTask_header'>
          <div className='newTask_header_cross_icon'>
            <svg onClick={() => {

              const unloadElement = document.getElementById('unloadViewDtl');
              if (unloadElement) {
                unloadElement.classList.add('fade-out');
              }
              setTimeout(function () {
                dispatch(setIsCommentView(false))
                dispatch(setTaskDetailFlag(false))
              }, 1000)
            }} width="22" height="22" style={{ marginLeft: '15px' }} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238" />
            </svg>
          </div>
          <div className='newTask_Profile_info'>
            <div className='newTask_userName'>
              <div className='img-holder'>
                <img src={selfInfo && selfInfo.empImg ? selfInfo.empImg : profile} alt="" onError={(e) => { e.target.onerror = null; e.target.src = profile; }} />
              </div>
              <p>{selfInfo.empFullName}</p>
            </div>
            <div className='newTask_Notification'>
              <svg width="32" height="33" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.10305 0.0128568L6.08027 0.000677966C5.99553 0.000677966 5.91098 0.000677967 5.82725 0C5.50742 0.125153 5.38125 0.362911 5.41313 0.69835C5.41818 0.751721 5.4168 0.805763 5.41543 0.859865C5.41422 0.907526 5.413 0.955249 5.41618 1.00258C5.42228 1.09552 5.39515 1.13147 5.29543 1.14809C3.54023 1.44045 2.20187 2.9908 2.16863 4.77177C2.16199 5.12331 2.16308 5.47485 2.16418 5.82639C2.16471 5.99514 2.16523 6.16388 2.1649 6.33263C2.16388 6.93432 2.03805 7.5065 1.76129 8.04306C1.54355 8.46499 1.25254 8.82892 0.895392 9.14231C0.486015 9.50081 0.420555 10.056 0.735304 10.4603C0.946607 10.732 1.23219 10.8358 1.56932 10.8354C3.84334 10.8341 6.11737 10.8342 8.39139 10.8344L10.3382 10.8344L10.3527 10.8344C10.3817 10.8345 10.4106 10.8345 10.4396 10.8331C11.0145 10.8022 11.411 10.3528 11.3615 9.78232C11.3364 9.49471 11.176 9.28544 10.967 9.09788C10.2426 8.44735 9.82436 7.63538 9.76399 6.6623C9.74285 6.32142 9.74376 5.97907 9.74467 5.63665C9.74528 5.40772 9.74589 5.17875 9.73991 4.95018C9.73279 4.67681 9.72092 4.39835 9.66529 4.13176C9.33935 2.56615 8.16413 1.43129 6.58733 1.1447C6.51136 1.13079 6.49033 1.1006 6.49169 1.0287C6.49508 0.859794 6.4961 0.690209 6.49033 0.521303C6.48253 0.296773 6.36789 0.140754 6.16676 0.045787C6.14529 0.035552 6.12419 0.0242147 6.10305 0.0128568Z" fill="#FF8402" />
                <path fillRule="evenodd" clipRule="evenodd" d="M1.94262 0.600171C0.731109 1.84831 0.087704 3.34235 0.00528583 5.07822C0.00528583 5.11598 0.00396383 5.15389 0.0026421 5.19179C-0.000322873 5.27683 -0.00328649 5.36182 0.00867773 5.44487C0.0449689 5.69721 0.25695 5.88002 0.503865 5.89121C0.771131 5.90342 0.996678 5.743 1.05773 5.48455C1.07558 5.40811 1.07737 5.32708 1.07915 5.24693C1.07953 5.22965 1.07991 5.21238 1.08045 5.19524C1.1103 4.27948 1.33788 3.41799 1.77948 2.61416C2.03352 2.15153 2.34793 1.73401 2.7183 1.35855C2.85363 1.22153 2.92926 1.0611 2.89535 0.86608C2.85736 0.647994 2.73085 0.497063 2.51717 0.431604C2.29095 0.362413 2.10305 0.434996 1.94262 0.600171ZM11.9034 5.07589C11.9034 5.11271 11.9047 5.14972 11.9059 5.18674C11.9088 5.26842 11.9116 5.35017 11.9007 5.42999C11.8613 5.7193 11.6202 5.90754 11.3288 5.89092C11.0561 5.87532 10.8329 5.64671 10.8296 5.36249C10.8221 4.73198 10.7292 4.11706 10.5257 3.51944C10.2628 2.74783 9.85139 2.06543 9.29482 1.47052C9.27796 1.45245 9.26085 1.4346 9.24373 1.41673C9.20818 1.37963 9.17255 1.34245 9.13914 1.30331C8.94615 1.07743 8.96006 0.759964 9.16966 0.558497C9.37893 0.35737 9.70792 0.343802 9.91312 0.55714C10.1556 0.809821 10.3917 1.07234 10.5999 1.35317C11.4187 2.45717 11.843 3.70395 11.9034 5.07589ZM7.92396 11.3788H3.97468C4.11679 12.2183 4.94877 13.0597 6.07956 12.9967C6.97633 12.9465 7.92362 12.1175 7.92396 11.3788Z" fill="#263238" />
              </svg>
            </div>
          </div>
        </div>
        <div className='taskDtl-srud-holder' ref={scrollContainerRef}>
          <div className='taskDtl-srud-holder-scroller' >
            <div className='TaskDtl-heading'>
              <div className='headingTask'>Task Title</div>
              <div className='updateTaskTitle'>
                <textarea id="updTitle" type='text' value={taskTitle} rows={5} onChange={(
                  selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
                  selfInfo.role[0].role === "ROLE_ADMIN" ||
                  editeKey === true ||
                  (empInfo.empId.toString() === selfInfo.empId.toString()) ||
                  (editeKey === false && selfInfo.empId?.toString() === taskDetailObject.taskOwner.empId?.toString()) ||
                  isHigherAuthority()
                ) ? (e) => { handleTaskTitle(e) } : null} />
                <p className='errorMsgforTskDtl1'>{`${100 - taskTitle.length} / 100`}</p>
                <div className='tstDtlRTA' onClick={() => {
                  if (taskTitle && taskTitle.length === 0 && taskTitle === '') {
                    toast.error("you can not  empty task", { toastId: 'success', autoClose: 2000 });
                  }
                  axios.post(`${apiUrl}task/regular/add`, { "regularTaskName": taskTitle, "employee": { "empId": selfInfo.empId } }, { headers: storedHeaders })
                    .then(response => {
                      toast.success("added successfully", { toastId: 'success', autoClose: 2000 });
                    })
                    .catch(error => {

                    })

                }} onMouseEnter={() => {
                  setPreDfnTip(true)
                }} onMouseLeave={() => {
                  setPreDfnTip(false)
                }}>
                  <svg width="11" height="11" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.56058 3.55538C7.80327 3.55538 8 3.75211 8 3.9948C8 4.23748 7.80327 4.43421 7.56058 4.43421H0.439417C0.196734 4.43421 0 4.23748 0 3.9948C0 3.75211 0.196734 3.55538 0.439418 3.55538L7.56058 3.55538ZM3.99817 0.000213715C4.24355 0.00033165 4.44241 0.199282 4.44241 0.444658V7.55534C4.44241 7.80089 4.24329 7.9999 3.99775 7.99979C3.75237 7.99967 3.55352 7.80072 3.55352 7.55534L3.55352 0.444658C3.55352 0.199115 3.75263 9.57001e-05 3.99817 0.000213715Z" fill="#263238" />
                  </svg>
                </div>
                {preDfnTip &&
                  <div className='tipForAdd'>Add to Predifined task</div>
                }

              </div>
            </div>

            <div className='taskEdtDate'>
              <div className='taskEdtDateHead'>
                Schedule Date :
              </div>
              <div className='taskEdtSelectDate'
              // onClick={(
              //   selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
              //   selfInfo.role[0].role === "ROLE_ADMIN" ||
              //   editeKey === true ||
              //   (empInfo.empId.toString() === selfInfo.empId.toString()) ||
              //   (editeKey === false && selfInfo.empId?.toString() === taskDetailObject.taskOwner.empId?.toString())) ? () => { setDateFlag(!dateFlag) } : null}
              >
                <p style={{ fontFamily: 'Roboto', fontSize: '15px', }}>{taskDetailObject.taskSchedule}</p>
                <div className='taskEdtSelectDateIcon'>
                  <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }} >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                    <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                    <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                  </svg>
                </div>
              </div>
            </div>

            <div className='taskEdtDate'>
              <div className='taskEdtDateHead'>
                Due Date :
              </div>

              <div className='taskEdtSelectDate' >
                <div className='taskEdtSelectDateNew' onClick={(
                  selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
                  selfInfo.role[0].role === "ROLE_ADMIN" ||
                  editeKey === true ||
                  (empInfo.empId.toString() === selfInfo.empId.toString()) ||
                  (editeKey === false && selfInfo.empId?.toString() === taskDetailObject.taskOwner.empId?.toString()) || isHigherAuthority() ) ? () => { setDateFlag(!dateFlag) } : null}>
                  <p style={{ fontFamily: 'Roboto', fontSize: '15px', }}>{DueDate}</p>
                  <div className='taskEdtSelectDateIcon'>
                    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }} >
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                      <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                      <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                    </svg>
                  </div>
                </div>

                {dateFlag &&
                  <div className='calender-holder-dashboard calender-holder-card' ref={dateRef}>
                    <div onClick={(e) => e.stopPropagation()}>
                      <Calendar value={moment(DueDate)._d} inline onChange={(e) => {
                        const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                        setStartDate(formattedDate)
                        if (taskDetailObject.taskDueDate.toString() !== formattedDate.toString()) {
                          setToUpdateObj(prevState => ({
                            ...prevState,
                            ['taskDueDate']: formattedDate
                          }));
                          toUpdateObj['taskDueDate'] = formattedDate;
                          setToUpdateObj(toUpdateObj)
                        } else {
                          setToUpdateObj(prevState => {
                            const newState = { ...prevState };
                            delete newState['taskDueDate'];
                            return newState;
                          });
                        }

                        setDateFlag(false)
                      }} unstyled={false} />
                    </div>
                  </div>
                }
              </div>
            </div>

            <div className='taskEdtTskOwn' >
              <div className='taskEdtDateHead'>
                Task Owner :
              </div>

              <div className='taskOwnDetailHolder' >
                <div className='taskOwnDetailHolder' onClick={selfInfo.role[0].role === "ROLE_SUPERADMIN" || selfInfo.role[0].role === "ROLE_ADMIN" || isHigherAuthority() ? () => {
                setAssigneeOption(true)
              } : null}>
                  <div className="taskOwnerImage"><img id="taskOwnerImage" src={selectedTaskOwner.empImg ? selectedTaskOwner.empImg : profile} alt="" onError={(e) => { e.target.onerror = null; e.target.src = profile; }} /></div>
                  <div className="AssigneeName"><p>{selectedTaskOwner.empFullName}</p></div>
                </div>


                {assigneeOption &&
                  <div className="listOfAsssigneeWrapper listOfAsssigneeWrapperDtl" style={{ zIndex: 1000 }} ref={assigneeRef}>
                    <div className="listOfAsssigneeWrapperScroller">
                      {assigness && assigness.length > 0 && assigness.map((emplObj) => (
                        <div className="AssigneDiv-name-img" onClick={() => {
                          setAssigneeOption(false)
                          var tempsSlectedTaskOwner = emplObj
                          setSelectedTaskOwner(tempsSlectedTaskOwner)
                          setAssigness(dAssignees?.filter(assigneeObj => assigneeObj?.empId.toString() !== emplObj?.empId.toString()))
                          if (taskDetailObject.taskOwner.empId.toString() !== tempsSlectedTaskOwner.empId.toString()) {
                            setToUpdateObj(prevState => ({
                              ...prevState,
                              ['taskOwner']: tempsSlectedTaskOwner.empId
                            }));
                            toUpdateObj['taskOwner'] = tempsSlectedTaskOwner.empId
                            setToUpdateObj(toUpdateObj)
                          } else {
                            delete toUpdateObj['taskOwner']
                            setToUpdateObj(toUpdateObj)
                          }
                        }}>
                          <div className="taskOwnerImage"><img id="taskOwnerImage" src={emplObj.empImg ? emplObj.empImg : profile} alt="" onError={(e) => { e.target.onerror = null; e.target.src = profile; }} /></div>
                          <div className="AssigneeName"><p>{emplObj?.empFullName}</p></div>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </div>

              {tagListForNewAddTask &&
                <div className='newAddTaskAssigneeList newAddTaskAssigneeListDtl' ref={newAddTagRef}>
                  <div className='seletedNewTaskAssignee'>
                    <div className='seletedNNewTaskAssigneeScroller'>
                      {departments && departments.length > 0 && departments.map((selectTagObj) => (
                        <div className='newTaskAssigneeContent tagForNewAddTask' style={{ backgroundColor: `${selectTagObj.departmentColorCode}` }}>
                          <p style={{ width: 'fit-content' }}>{selectTagObj.departmentName}</p>
                          <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              const updatedList = departments.filter(obj => obj !== selectTagObj);
                              setDepartments(updatedList);
                              tagsList.push(selectTagObj)
                              setTagsList(tagsList)
                            }}>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.139669 4.85991C-0.0465561 4.6737 -0.0465563 4.3718 0.139668 4.18559L1.8254 2.5L0.139668 0.814411C-0.0465563 0.628202 -0.0465561 0.326298 0.139669 0.140089C0.325894 -0.0461199 0.627824 -0.0461202 0.814049 0.140089L2.49978 1.82568L4.18595 0.139656C4.37218 -0.0465523 4.67411 -0.0465521 4.86033 0.139657C5.04656 0.325866 5.04656 0.62777 4.86033 0.813978L3.17416 2.5L4.86033 4.18602C5.04656 4.37223 5.04656 4.67413 4.86033 4.86034C4.67411 5.04655 4.37218 5.04655 4.18595 4.86034L2.49978 3.17432L0.814049 4.85991C0.627824 5.04612 0.325894 5.04612 0.139669 4.85991Z" fill="#263238" fill-opacity="0.6" />
                          </svg>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className='newTaskAssineeListContainer  newTaskTagsListContainer'>
                    {tagsList && tagsList.length > 0 && tagsList.map((tagObj) => (
                      <div className='TagContentDiv' style={{ backgroundColor: `${tagObj.departmentColorCode}` }} key={tagObj}
                        onClick={() => {
                          const isDefaultTag = tagObj.departmentId === selfInfo.department?.departmentId;
                          setTagsList(tagsList?.filter(obj => obj?.departmentId !== tagObj?.departmentId))
                          // Check if the tagObj is already in the selectedTagsForList
                          const isTagAlreadySelected = departments.some(item => item.departmentId === tagObj.departmentId);
                          if (!isTagAlreadySelected || departments.length === 0) {
                            setDepartments(previousDepertments => [...previousDepertments, tagObj]);
                          }
                        }}>
                        <p>{tagObj.departmentName}</p>
                      </div>
                    ))}
                  </div>
                </div>
              }
            </div>

            <div className='DeprtEdtHolder'>
              <div className='taskEdtDateHead'>
                Department :
              </div>
              <div className='DeprtEdtHolderupdate' onClick={(
                selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
                selfInfo.role[0].role === "ROLE_ADMIN" ||
                editeKey === true ||
                (empInfo.empId.toString() === selfInfo.empId.toString()) ||
                (editeKey === false && selfInfo.empId?.toString() === taskDetailObject.taskOwner.empId?.toString()) || isHigherAuthority()) ? () => {
                  setTagListInNewTaskAdd(true)
                } : null}>

                <div className='DeprtEdtHolderupdatescroll'>
                  {
                    departments && departments.length > 0 && departments.map((tag) => (
                      <div className='newTaskTagContent' style={{ backgroundColor: `${tag.departmentColorCode}` }} >
                        <p style={{ width: 'fit-content' }}>{tag.departmentName}</p>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>

            <div className='taskDtlStatusHolder'>

              <div className='taskEdtDateHead'>
                Status :
              </div>

              <div className='newTaskAddAssigneeDiv'>

                {((selfInfo.role[0].role !== 'ROLE_SUPERADMIN' && selfInfo.role[0].role !== "ROLE_ADMIN") && ((route === 'mytask' && taskDetailObject.taskOwner.empId === selfInfo.empId && taskDetailObject.taskView.length === 0) ||
                  ((selfInfo.role[0].role !== 'ROLE_SUPERADMIN' && selfInfo.role[0].role !== "ROLE_ADMIN") && (route === 'level' && selfInfo.empId === taskEmp.empId && taskDetailObject.taskOwner.empId === taskEmp.empId && taskDetailObject.taskView.length === 0))
                )) &&
                  <div className='taskVewAccessDetailTsk'>
                  </div>
                }
                <div className='newAddTaskAssignee' onClick={
                  (selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
                    selfInfo.role[0].role === "ROLE_ADMIN" ||
                    editeKey === true ||
                    (empInfo.empId.toString() === selfInfo.empId.toString()) ||
                    ((selfInfo.role[0].roleLevel < selfInfoEmp.role[0].roleLevel) && !isView()) ||
                    isHigherAuthority() || 
                    (editeKey === false && selfInfo.empId?.toString() === taskDetailObject.taskOwner.empId?.toString())) ? () => {
                      if(formattedDateString < formattedDateComp && (parseInt(taskDetailObject.statusEntity.statusId) !== 5 && parseInt(taskDetailObject.statusEntity.statusId) !== 6)){
                     
                        setStatusListForNewAddTask(!true)
                      }else{
                        setStatusListForNewAddTask(!statusListForNewAddTask)
                      }
                    } : null}>
                  <div className=' newTasStatusContentEdite' style={{ backgroundColor: selectedStatus ? `${selectedStatus.statusColorCode}` : null }}>
                    {selectedStatus ? selectedStatus.status : null}
                    {selectedStatus && selectedStatus.statusId === 5 &&
                      <div className="requestedBox"></div>
                    }
                  </div>
                </div>
                {statusListForNewAddTask &&
                  <div className='newAddTaskAssigneeList newAddTaskStatusList' ref={newAddStatusRef}>
                    <div className='seletedNewTaskAssignee'>
                      <div className='seletedNNewTaskAssigneeScroller'>
                        <div className='newTaskAssigneeContent newTaskPriorityContent' style={{ backgroundColor: selectedStatus ? `${selectedStatus.statusColorCode}` : null }}>
                          <p style={{ width: 'fit-content' }}>{selectedStatus ? selectedStatus.status : null}</p>
                        </div>
                      </div>
                    </div>
                    <div className='newTaskAssineeListContainer newTaskTagsListContainer'>
                      {(selfInfo.role[0].role !== "ROLE_SUPERADMIN" && selfInfo.role[0].role !== "ROLE_ADMIN") && (
                        statusList && statusList.length > 0 && statusList.map((statusObj) => (
                          (statusObj.statusId !== 6) && (
                            <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                              var tempSelectedStatus = statusObj
                              setSelectedStatus(statusObj)
                              setStatusList(dStatuses?.filter(obj => obj?.statusId !== statusObj?.statusId))
                              setStatusListForNewAddTask(!statusListForNewAddTask)
                              if (taskDetailObject.statusEntity.statusId.toString() !== tempSelectedStatus.statusId.toString()) {
                                setToUpdateObj(prevState => ({
                                  ...prevState,
                                  ['taskStatus']: tempSelectedStatus.statusId,
                                  ['date']: fullDateF2
                                }));
                                toUpdateObj['taskStatus'] = tempSelectedStatus.statusId
                                toUpdateObj['date'] = fullDateF2
                                setToUpdateObj(toUpdateObj)
                              } else {
                                delete toUpdateObj['taskStatus']
                                delete toUpdateObj['date']
                                setToUpdateObj(toUpdateObj)
                              }
                            }}>
                              {statusObj.status}
                            </div>
                          )
                        ))
                      )}

                      {(selfInfo.role[0].role === "ROLE_ADMIN") && (
                        (route === 'mytask') ?
                          (taskDetailObject.taskOwner.empId !== selfInfo.empId) ? (
                            statusList && statusList.length > 0 && statusList.map((statusObj) => (
                              (statusObj.statusId !== 6) && (
                                <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                  var tempSelectedStatus = statusObj;
                                  setSelectedStatus(statusObj);
                                  setStatusList(dStatuses?.filter(obj => obj?.statusId !== statusObj?.statusId))
                                  setStatusListForNewAddTask(!statusListForNewAddTask);
                                  if (taskDetailObject.statusEntity.statusId.toString() !== tempSelectedStatus.statusId.toString()) {
                                    setToUpdateObj(prevState => ({
                                      ...prevState,
                                      ['taskStatus']: tempSelectedStatus.statusId,
                                      ['date']: fullDateF2
                                    }));
                                    toUpdateObj['taskStatus'] = tempSelectedStatus.statusId;
                                    toUpdateObj['date'] = fullDateF2
                                    setToUpdateObj(toUpdateObj);
                                  } else {
                                    delete toUpdateObj['taskStatus'];
                                    delete toUpdateObj['date']
                                    setToUpdateObj(toUpdateObj);
                                  }
                                }}>
                                  {statusObj.status}
                                </div>
                              )
                            ))
                          ) : (
                            statusList && statusList.length > 0 && statusList.map((statusObj) => (
                              <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                var tempSelectedStatus = statusObj;
                                setSelectedStatus(statusObj);
                                setStatusList(dStatuses?.filter(obj => obj?.statusId !== statusObj?.statusId))
                                setStatusListForNewAddTask(!statusListForNewAddTask);
                                if (taskDetailObject.statusEntity.statusId.toString() !== tempSelectedStatus.statusId.toString()) {
                                  setToUpdateObj(prevState => ({
                                    ...prevState,
                                    ['taskStatus']: tempSelectedStatus.statusId,
                                    ['date']: fullDateF2
                                  }));
                                  toUpdateObj['taskStatus'] = tempSelectedStatus.statusId;
                                  toUpdateObj['date'] = fullDateF2
                                  setToUpdateObj(toUpdateObj);
                                } else {
                                  delete toUpdateObj['taskStatus'];
                                  delete toUpdateObj['date']
                                  setToUpdateObj(toUpdateObj);
                                }
                              }}>
                                {statusObj.status}
                              </div>
                            ))
                          )
                          : (
                            (selfInfo.empId === selfInfoEmp.empId) ? (
                              (taskDetailObject.taskOwner.empId !== selfInfo.empId) ? (
                                statusList && statusList.length > 0 && statusList.map((statusObj) => (
                                  (statusObj.statusId !== 6) && (
                                    <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                      var tempSelectedStatus = statusObj;
                                      setSelectedStatus(statusObj);
                                      setStatusList(dStatuses?.filter(obj => obj?.statusId !== statusObj?.statusId))
                                      setStatusListForNewAddTask(!statusListForNewAddTask);
                                      if (taskDetailObject.statusEntity.statusId.toString() !== tempSelectedStatus.statusId.toString()) {
                                        setToUpdateObj(prevState => ({
                                          ...prevState,
                                          ['taskStatus']: tempSelectedStatus.statusId,
                                          ['date']: fullDateF2
                                        }));
                                        toUpdateObj['taskStatus'] = tempSelectedStatus.statusId;
                                        toUpdateObj['date'] = fullDateF2
                                        setToUpdateObj(toUpdateObj);
                                      } else {
                                        delete toUpdateObj['taskStatus'];
                                        delete toUpdateObj['date']
                                        setToUpdateObj(toUpdateObj);
                                      }
                                    }}>
                                      {statusObj.status}
                                    </div>
                                  )
                                ))
                              ) : (
                                statusList && statusList.length > 0 && statusList.map((statusObj) => (
                                  <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                    var tempSelectedStatus = statusObj;
                                    setSelectedStatus(statusObj);
                                    setStatusList(dStatuses?.filter(obj => obj?.statusId !== statusObj?.statusId))
                                    setStatusListForNewAddTask(!statusListForNewAddTask);
                                    if (taskDetailObject.statusEntity.statusId.toString() !== tempSelectedStatus.statusId.toString()) {
                                      setToUpdateObj(prevState => ({
                                        ...prevState,
                                        ['taskStatus']: tempSelectedStatus.statusId
                                        ['date'] = fullDateF2
                                      }));
                                      toUpdateObj['taskStatus'] = tempSelectedStatus.statusId;
                                      toUpdateObj['date'] = fullDateF2
                                      setToUpdateObj(toUpdateObj);
                                    } else {
                                      delete toUpdateObj['taskStatus'];
                                      delete toUpdateObj['date']
                                      setToUpdateObj(toUpdateObj);
                                    }
                                  }}>
                                    {statusObj.status}
                                  </div>
                                ))
                              )
                            ) : (
                              statusList && statusList.length > 0 && statusList.map((statusObj) => (
                                <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                  var tempSelectedStatus = statusObj;
                                  setSelectedStatus(statusObj);
                                  setStatusList(dStatuses?.filter(obj => obj?.statusId !== statusObj?.statusId))
                                  setStatusListForNewAddTask(!statusListForNewAddTask);
                                  if (taskDetailObject.statusEntity.statusId.toString() !== tempSelectedStatus.statusId.toString()) {
                                    setToUpdateObj(prevState => ({
                                      ...prevState,
                                      ['taskStatus']: tempSelectedStatus.statusIdl,
                                      ['date']: fullDateF2
                                    }));
                                    toUpdateObj['taskStatus'] = tempSelectedStatus.statusId;
                                    toUpdateObj['date'] = fullDateF2
                                    setToUpdateObj(toUpdateObj);
                                  } else {
                                    delete toUpdateObj['taskStatus'];
                                    delete toUpdateObj['date']
                                    setToUpdateObj(toUpdateObj);
                                  }
                                }}>
                                  {statusObj.status}
                                </div>
                              ))
                            )
                          ))}

                      {(selfInfo.role[0].role === "ROLE_SUPERADMIN") && (
                        statusList && statusList.length > 0 && statusList.map((statusObj) => (
                          <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                            var tempSelectedStatus = statusObj;
                            setSelectedStatus(statusObj);
                            setStatusList(dStatuses?.filter(obj => obj?.statusId !== statusObj?.statusId))
                            setStatusListForNewAddTask(!statusListForNewAddTask);
                            if (taskDetailObject.statusEntity.statusId.toString() !== tempSelectedStatus.statusId.toString()) {
                              setToUpdateObj(prevState => ({
                                ...prevState,
                                ['taskStatus']: tempSelectedStatus.statusId,
                                ['date']: fullDateF2
                              }));
                              toUpdateObj['taskStatus'] = tempSelectedStatus.statusId;
                              toUpdateObj['date'] = fullDateF2
                              setToUpdateObj(toUpdateObj);
                            } else {
                              delete toUpdateObj['taskStatus'];
                              delete toUpdateObj['date']
                              setToUpdateObj(toUpdateObj);
                            }
                          }}>
                            {statusObj.status}
                          </div>
                        ))
                      )}

                    </div>
                  </div>
                }
              </div>
            </div>

            <div className='taskDtlStatusHolder'>
              <div className='taskEdtDateHead'>
                Priority :
              </div>

              <div className='newTaskAddAssigneeDiv'>
                <div className='newAddTaskAssignee' onClick={(selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
                  selfInfo.role[0].role === "ROLE_ADMIN" ||
                  editeKey === true ||
                  (empInfo.empId.toString() === selfInfo.empId.toString()) ||
                  (editeKey === false && selfInfo.empId?.toString() === taskDetailObject.taskOwner.empId?.toString()) || isHigherAuthority()) ? () => {
                    setPriorityListForNewAddTask(!priorityListForNewAddTask)
                  } : null}>
                  <div className='newTaskAssigneeContent newnewTaskAssigneeContentEdite' style={{ backgroundColor: selectedPriority ? `${selectedPriority.priorityColorCode}` : null }}>
                    <p style={{ width: 'fit-content' }}>{selectedPriority ? selectedPriority.priority : null}</p>
                  </div>
                </div>
                {priorityListForNewAddTask &&
                  <div className='newAddTaskAssigneeList' ref={newAddPriorityRef}>
                    <div className='seletedNewTaskAssignee'>
                      <div className='seletedNNewTaskAssigneeScroller'>
                        <div className='newTaskAssigneeContent newTaskPriorityContent' style={{ backgroundColor: selectedPriority ? `${selectedPriority.priorityColorCode}` : null }}>
                          <p style={{ width: 'fit-content' }}>{selectedPriority ? selectedPriority.priority : null}</p>
                        </div>
                      </div>
                    </div>
                    <div className='newTaskAssineeListContainer newTaskTagsListContainer'>
                      {priorityList && priorityList.length > 0 && priorityList.map((priorityObj) => (
                        <div className='TagContentDiv' style={{ backgroundColor: priorityObj ? `${priorityObj.priorityColorCode}` : null }} key={priorityObj.priorityId}
                          onClick={() => {
                            var tempSelectedPriority = priorityObj
                            setSelectedPriority(priorityObj)
                            setPriorityList(dPriorities?.filter(obj => obj?.priorityId !== priorityObj?.priorityId))
                            setPriorityListForNewAddTask(!priorityListForNewAddTask)
                            if (taskDetailObject.priorityEntity.priorityId.toString() !== tempSelectedPriority.priorityId.toString()) {
                              setToUpdateObj(prevState => ({
                                ...prevState,
                                ['taskPriority']: tempSelectedPriority.priorityId
                              }));
                              toUpdateObj['taskPriority'] = tempSelectedPriority.priorityId
                              setToUpdateObj(toUpdateObj)

                            } else {
                              delete toUpdateObj['taskPriority']
                              setToUpdateObj(toUpdateObj)
                            }
                          }}>
                          <p>{priorityObj.priority}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </div>
            </div>

            <div className='taskDtlStatusHolder'>
              <div className='taskEdtDateHead'>
                Project  :
              </div>

              <div className='newTaskAddAssigneeDiv'>
                <div className='newAddTaskAssignee' onClick={(selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
                  selfInfo.role[0].role === "ROLE_ADMIN" ||
                  editeKey === true ||
                  (empInfo.empId.toString() === selfInfo.empId.toString()) ||
                  (editeKey === false && selfInfo.empId?.toString() === taskDetailObject.taskOwner.empId?.toString()) || isHigherAuthority()) ? () => {
                    setProjectLitForNewAddTask(!projectListForNewAddTask)
                  } : null}>
                  <div className='newTaskAssigneeContent newnewTaskAssigneeContentEdite' >
                    <p style={{ width: 'fit-content' }}>{selectedProject ? selectedProject.projectName : null}</p>
                  </div>
                </div>
                {projectListForNewAddTask &&
                  <div className='newAddTaskAssigneeList newAddTaskStatusList' ref={newAddProjectRef}>
                    <div className='seletedNewTaskAssignee'>
                      <div className='seletedNNewTaskAssigneeScroller'>
                        <div className='newTaskAssigneeContent newTaskPriorityContent'>
                          <p style={{ width: 'fit-content' }}>{selectedProject ? selectedProject.projectName : null}</p>
                        </div>
                      </div>
                    </div>
                    <div className='newTaskAssineeListContainer newTaskTagsListContainer'>
                      <div className='prjScroller'>
                        {projectListTemp  && projectListTemp.map((projectObj) => (
                          <div className='TagContentDiv' key={projectObj.projectId}
                            onClick={() => {
                              var tempSelectedProject = projectObj
                              setSelectedProject(projectObj)
                              setIsGitProject(false)
                              setProjectListTamp(tempPorjectList?.filter(obj => obj?.projectId !== projectObj.projectId))
                              setProjectLitForNewAddTask(!projectListForNewAddTask)
                              if (taskDetailObject.projectEntity === null || taskDetailObject.projectEntity?.projectId.toString() !== tempSelectedProject.projectId.toString()) {
                                setToUpdateObj(prevState => ({
                                  ...prevState,
                                  ['taskProject']: tempSelectedProject.projectId
                                }));
                                toUpdateObj['taskProject'] = tempSelectedProject.projectId
                                setIsGitProject(false)
                                setToUpdateObj(toUpdateObj)
                              } else {
                                delete toUpdateObj['taskProject']
                                setToUpdateObj(toUpdateObj)
                              }
                            }}>
                            <p>{projectObj.projectName}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                    {selectedProject !== null &&
                      <div className='clearPrjDtl' onClick={() => {
                        var tempselectedProject = null
                        setSelectedProject(tempselectedProject)
                        setProjectListTamp(tempPorjectList)
                        if (taskDetailObject?.projectEntity === null && tempselectedProject === null) {
                          delete toUpdateObj['taskProject']
                          setToUpdateObj(toUpdateObj)
                          setIsGitProject(true)
                        } else {
                          setIsGitProject(false)
                          setToUpdateObj(prevState => ({
                            ...prevState,
                            ['taskProject']: null
                          }));
                          toUpdateObj['taskProject'] = null
                          setToUpdateObj(toUpdateObj)
                          setIsGitProject(true)
                        }
                      }}>Clear</div>
                    }
                  </div>
                }
              </div>
            </div>

            <div className='taskDtlStatusHolder'>
              <div className='taskEdtDateHead'>
                Verified  :
              </div>

              <div className='newTaskAddAssigneeDiv'>
                <div className='newAddTaskAssignee' onClick={(selfInfo.department.departmentName === "QA" ||
                  selfInfo.role[0].role === "ROLE_SUPERADMIN" ||
                  selfInfo.role[0].role === "ROLE_ADMIN" ||
                  isHigherAuthority()
                ) ? () => {
                  setVerifiedListForNewAddTask(!verifiedListForNewAddTask)
                } : null}>
                  <div className='newTaskAssigneeContent newnewTaskAssigneeContentEdite' style={{ backgroundColor: selectedVerified && selectedVerified.verificationColorCode }} >
                    <p style={{ width: 'fit-content' }}>{selectedVerified ? selectedVerified.verificationStatus : null}</p>
                  </div>
                </div>
                {verifiedListForNewAddTask &&
                  <div className='newAddTaskAssigneeList newAddTaskStatusList' ref={newAddVerifiedRef}>
                    <div className='seletedNewTaskAssignee'>
                      <div className='seletedNNewTaskAssigneeScroller'>
                        <div className='newTaskAssigneeContent newTaskPriorityContent' style={{ backgroundColor: selectedVerified && selectedVerified.verificationColorCode }}>
                          <p style={{ width: 'fit-content' }}>{selectedVerified ? selectedVerified.verificationStatus : null}</p>
                        </div>
                      </div>
                    </div>
                    <div className='newTaskAssineeListContainer newTaskTagsListContainer'>
                      {verifiedList && verifiedList.length > 0 && verifiedList.map((verifiedObj) => (
                        <div style={{ backgroundColor: verifiedObj && verifiedObj.verificationColorCode }} className='TagContentDiv' key={verifiedObj.verificationStatusId}
                          onClick={() => {
                            var tempSelectedVerified = verifiedObj
                            setSelectedVerified(verifiedObj)
                            setVerifiedListForNewAddTask(!verifiedListForNewAddTask)
                            setVerifiedList(dVerifieds?.filter(obj => obj?.verificationStatusId !== verifiedObj?.verificationStatusId))
                            if (taskDetailObject.task_verified?.verificationStatusId.toString() !== tempSelectedVerified.verificationStatusId.toString()) {
                              setToUpdateObj(prevState => ({
                                ...prevState,
                                ['taskVerificationStatus']: tempSelectedVerified.verificationStatusId
                              }));
                              toUpdateObj['taskVerificationStatus'] = tempSelectedVerified.verificationStatusId
                              setToUpdateObj(toUpdateObj)
                            } else {
                              delete toUpdateObj['taskVerificationStatus']
                              setToUpdateObj(toUpdateObj)
                            }
                          }}>
                          <p>{verifiedObj.verificationStatus}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className='taskDtlGitHolder' style={{ height: selfInfo?.department?.departmentId !== 3 ? '70px' : '50px'}}>
              <div className='taskEdtDateHead'>
                GitLink  :
              </div>
              <div className='cmtDivDetlTask'>
                <input id="taskDtlgit" type='text' value={gitLink} disabled={isGitProject} placeholder={ isGitProject ? 'Select the project first...'  : 'enter git link'} onChange={(selfInfo.role[0].role === "ROLE_ADMIN" ||
                  editeKey === true ||
                  (empInfo.empId.toString() === selfInfo.empId.toString()) ||
                  (editeKey === false && selfInfo.empId?.toString() === taskDetailObject?.taskOwner.empId?.toString())) ? (e) => {
                    // setGitLink(e.target.value)
                    handleGitLink(e)
                  } : null} />
                  {  selfInfo?.department?.departmentId !== 3 && 
                    <div className='git-toggle-holder'>
                    <input type='checkbox' disabled={gitLink === null || gitLink === '' || isGitProject} onChange={() => {
                      setTaskToTest(!taskToTest)
                      if(taskToTest === false){
                      setToUpdateObj(prevState => ({
                        ...prevState,
                        ['taskToTest']: !taskToTest
                      }));
                    }else{
                      delete toUpdateObj['taskToTest']
                      setToUpdateObj(toUpdateObj)
                    }
                    }}/>send to tester
                    </div>
                  }
                  
              </div>
            </div>

            <div className='taskDtlCommentsHolder'>
              <div className='taskEdtDateHead'>
                <div className='img-holder'>
                  <img style={{ height: '99%', width: '100%' }} src={selfInfoEmp?.empImg ? selfInfoEmp?.empImg : profile} id="newTaskAssigneeImg" alt='/' onError={(e) => { e.target.onerror = null; e.target.src = profile; }} />
                </div>
              </div>
              {/* <div className='newTaskCommetnsDiv '>
                <textarea className="upDateComments " type='text' value={taskComment} placeholder={'enter task comment'} onChange={(e) => {
                  // setTaskComment(e.target.value)
                  handleTaskComment(e)
                }} />
              </div> */}
              <div className='comment-box'>{
                // text != null ?
                // <Editor value={text} onTextChange={(e) => {
                //   setText(e.htmlValue ? e.htmlValue : '')
                //   handleTaskComment(e)
                // }} style={{ height: '320px' }} /> 
                // <Editor value="Always bet on Prime!" readOnly style={{ height: '320px' }} />
                <CKEditor
                  editor={ClassicEditor}
                  data={text}
                  onReady={isCommentView ? (editor) => {
                    // Store the editor instance in the ref and focus it
                    editorRef.current = editor;
                    editor.focus();
                  } : null}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    const reqData = {
                      editorData: editor.getData(),
                      plainData: extractPlainText(data)
                    }
                    handleTaskComment(JSON.stringify(reqData))
                    setText(data);
                  }}
                />
                // : null
              }
              </div>
            </div>

            <div className='taskDtlStatusHolder'>
              <div className='taskEdtDateHead'>
                Approved by :
              </div>
            { viewDetailFlag && taskDetailObject.taskView.length > 0 && 
              <div className='viewHighAuthDetails'>
                  <div className='viewHighAuthScroller'>
                  {taskDetailObject.taskView?.map((obj, index) => (
                      <div className="ViewEmpInfo" key={index}>
                        <div className="taskOwnerImage viewedByDiv">
                          <img id="taskOwnerImage" src={obj ? obj.empImg : profile} alt="" onError={(e) => { e.target.onerror = null; e.target.src = profile; }} />
                        </div>
                        <div>{obj.empFullName}</div>
                        <div>{obj.viewedTimeStamp}</div>
                      </div>
                    ))}
                  </div>
              </div>
            }

              <div className='newTaskAddAssigneeDiv'>
                <div className='newAddTaskAssignee' onClick={() => { setViewDetailFlag(true) }}>
                  <div className='newTaskAssigneeContent newnewTaskAssigneeContentEdite'>
                    <>
                      {parseInt(selfInfo?.role[0]?.roleLevel) < parseInt(selfInfoEmp?.role[0]?.roleLevel) ? (
                        <>
                          {taskDetailObject.taskView.map((obj, index) => (
                            <div key={index} style={{ position: 'absolute', left: `${20 * index}px`, background: '#fff' }} className="taskOwnerImage viewedByDiv" 
                            onMouseEnter={() =>{setViewDetailFlag(true)}}
                            onMouseLeave={() => {setViewDetailFlag(false)}}
                            >
                              <img id="taskOwnerImage" src={obj ? obj.empImg : profile} alt="" onError={(e) => { e.target.onerror = null; e.target.src = profile; }} />
                            </div>
                          ))}

                          {!isView() === false && parseInt(selfInfo?.role[0]?.roleLevel) < parseInt(selfInfoEmp?.role[0]?.roleLevel) && (
                            <div className='approve-task taskDtl-approve-task' onClick={() => {
                              let currentTime = new Date();
                              let hours = currentTime.getHours();
                              let minutes = currentTime.getMinutes();
                              let seconds = currentTime.getSeconds();

                              if (hours < 10) {
                                hours = '0' + hours;
                              }
                              if (minutes < 10) {
                                minutes = '0' + minutes;
                              }
                              if (seconds < 10) {
                                seconds = '0' + seconds;
                              }

                              const today = new Date();
                              const year = today.getFullYear();
                              const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
                              const day = String(today.getDate()).padStart(2, '0');
                              const todayDateFor = `${month}-${day}-${year}`;
                              let formattedTime = todayDateFor + '  ' + hours + ':' + minutes + ':' + seconds;

                              defaultSelectedView.push({
                                "empId": selfInfo.empId,
                                "empFullName": selfInfo.empFullName,
                                "empImg": selfInfo.empImg,
                                "viewedTimeStamp": formattedTime
                              });
                              setViewFlag(true)
                              setDeafultSelctedView(defaultSelectedView);
                            }}>Approve</div>
                          )}
                        </>
                      ) : (
                        taskDetailObject && taskDetailObject?.taskView?.length > 0 ? (
                          taskDetailObject.taskView.map((obj, index) => (
                            <div key={index} style={{ position: 'absolute', left: `${20 * index}px`, background: '#fff' }} className="taskOwnerImage viewedByDiv" 
                              onMouseEnter={() =>{setViewDetailFlag(true)}}
                              onMouseLeave={() => {setViewDetailFlag(false)}}
                            >
                              <img id="taskOwnerImage" src={obj ? obj.empImg : profile} alt="" onError={(e) => { e.target.onerror = null; e.target.src = profile; }} />
                            </div>
                          ))
                        ) : (
                          <div className='approve-task' style={{ background: '#ff0000ad' }}>Not Approved</div>
                        )
                      )}
                      </> 
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        {toUpdateObj && Object.keys(toUpdateObj)?.length > 2 &&
          <div className='savend_cnl-holder'>
            <button id="btnSave" onClick={() => {
              setUpdateLoader(true)
              UPDATE()
            }}>{updateLoader ? <div className="taskUpdateLoader"></div> : 'Save'}</button>
            <button id='btnCnl' onClick={() => {
              defaultSelectedView.slice(1, defaultSelectedView.length - 1)
              setUpdateLoader(false)
              setCofirmBtn(true)

            }}
            >Cancel</button>
          </div>
        }
      </div>
      {confirmBtn &&
        <div className='confirmUpdatTskChnge'>
          <div className='confirmCardChangesClr'>
            <div className='headingConfirmation'>
              Do you want to cancel these changes ?
            </div>
            <div className='headingConfirmation'>
              <button className='btn1Yes' onClick={() => {
                setTaskTitle(taskDetailObject?.taskTitle)
                setStartDate(taskDetailObject?.taskDueDate)
                setSelectedTaskOwner(taskDetailObject?.taskOwner)
                setDepartments(taskDetailObject?.tags)
                setSelectedStatus(taskDetailObject?.statusEntity)
                setSelectedPriority(taskDetailObject?.priorityEntity)
                setSelectedProject(taskDetailObject?.projectEntity)
                setSelectedVerified(taskDetailObject?.task_verified)
                setGitLink(taskDetailObject?.taskGitLink)
                setText(taskDetailObject.taskComment ? removeStringParse(taskDetailObject.taskComment) : '') 
                var temp = defaultSelectedView.slice(0, defaultSelectedView?.length - 2)
                setDeafultSelctedView(temp)
                setCofirmBtn(false)
                setToUpdateObj({ "taskId": taskDetailObject?.taskId, "empId": mtiID === true ? null : taskEmp?.empId })
                setViewFlag(false)
              }}>Yes</button>
              <button className='btn2No' onClick={() => {
                setCofirmBtn(false)
              }}>No</button>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default TaskDetails
